import { Link, useLocation } from "react-router-dom";
import NoData from "../NoData";

function BvnVerificationStatus() {
  const { search } = useLocation();

  const params = new URLSearchParams(search);
  const status = params.get("status");
  const tid = params.get("tid");

  if (!status || !tid) {
    return (
      <NoData
        title="Uh Oh!"
        message="Verification data not found! Kindly ensure you have provided the correct BVN and try again."
        buttonText="Back to Home"
        buttonLink="/"
      />
    );
  }

  return (
    <>
      <section className="section-border border-primary">
        <div className="container d-flex flex-column">
          <div className="row align-items-center justify-content-center gx-0 min-vh-100">
            <div className="col-12 col-md-5 col-lg-4 order-md-1 mb-auto mb-md-0 pb-8 py-md-11 mt-8">
              <div className="text-center mb-3">
                {status === "success" ? (
                  <i className="fe fe-check-circle text-primary display-3"></i>
                ) : (
                  <i className="fe fe-alert-circle text-danger display-3"></i>
                )}
              </div>
              <h1 className="mb-0 fw-bold text-center text-primary">BVN Verification</h1>
              <p className="mb-6 text-center text-muted">
                {status === "success"
                  ? "You have successfully verified your BVN with us"
                  : "Sorry, we encountered an error verifying your BVN. Please, ensure it is correct and try again."}
              </p>

              <div>
                {status === "success" ? (
                  <Link
                    className="btn w-100 btn-primary"
                    to={`/onboarding?tid=${tid}`}
                    replace
                  >
                    Continue to onboarding
                  </Link>
                ) : (
                  <Link
                    className="btn w-100 btn-outline-primary"
                    to="/signup"
                    replace
                  >
                    Back to Signup
                  </Link>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default BvnVerificationStatus;
